import { ReactNode, useMemo } from 'react';

export interface FormattedNumberProps extends Intl.NumberFormatOptions {
  children: ReactNode;
  locales?: string[] | string;
}

function getNumDigits(numToFormat: number, props: FormattedNumberProps) {
  let minDigits, maxDigits;
  if (props.style == 'currency') {
    // Should display $1,000.10 not $1,000.1
    minDigits = numToFormat % 1 == 0 ? (maxDigits = 0) : 2;
  }

  return [minDigits, maxDigits];
}

function getFormatted(props: FormattedNumberProps) {
  if (typeof props.children !== 'string' && typeof props.children !== 'number') {
    return props.children;
  }

  const numToFormat = Number.parseFloat(props.children.toString());
  const [minDigits, maxDigits] = getNumDigits(numToFormat, props);

  if (Number.isNaN(numToFormat)) return props.children;

  return Intl.NumberFormat(props.locales, {
    minimumFractionDigits: props.minimumFractionDigits ?? minDigits,
    maximumFractionDigits: props.maximumFractionDigits ?? maxDigits,
    ...props,
  })
    .format(numToFormat)
    .toLowerCase();
}

export const FormattedNumber = ({ locales = 'en-us', currency = 'USD', ...props }: FormattedNumberProps) => {
  const formatted = useMemo(() => {
    return getFormatted({ locales, currency, ...props });
  }, [locales, currency, props]);

  return <>{formatted}</>;
};

export default FormattedNumber;
